import { EKnowledgeShareMode } from "@frontend-shared/types";

// NOTE: Canonical field keys come from the server (EAssistantChangedField).
// Mapped to literal i18n keys so react-i18next strict typing doesn't widen
// to `string`. Unknown keys fall through to the raw value — keeps the card
// forward-compatible if the server adds a new field before the catalog
// catches up.
export const FIELD_LABEL_KEYS = {
  name: "type.assistant_edited.fields.name",
  description: "type.assistant_edited.fields.description",
  instructions: "type.assistant_edited.fields.instructions",
  avatar: "type.assistant_edited.fields.avatar",
  model: "type.assistant_edited.fields.model",
  files: "type.assistant_edited.fields.files",
  integrations: "type.assistant_edited.fields.integrations",
  docs_support: "type.assistant_edited.fields.docs_support",
  images_support: "type.assistant_edited.fields.images_support",
} as const;

// NOTE: Per-mode i18n keys kept as literal strings so the strict react-i18next
// typing doesn't widen to `string`. Using a Record lookup (instead of a
// switch) preserves TS exhaustiveness over EKnowledgeShareMode without
// tripping ESLint's `consistent-return` on the implicit fall-through path.
export const BODY_KEY_BY_SHARE_MODE = {
  [EKnowledgeShareMode.DIRECT]: "type.knowledge_file_shared.body_direct",
  [EKnowledgeShareMode.PROJECT_ALL]:
    "type.knowledge_file_shared.body_project_all",
  [EKnowledgeShareMode.PUBLIC]: "type.knowledge_file_shared.body_public",
} as const;
